import i18n from '@i18next/i18n';
import { DrawerName } from '@framework/workbench/drawer/constants';
import { TOOLBAR_SHAPE, TOOLBAR_ANIM, TOOLBAR_SELECT_WINDOW } from '@editor/src/img/pageIndex';
import INSERT_COMMENT_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_add_comment_20.svg';

export const TabPanelNameMap = {
    [DrawerName.SLIDE_PROPERTY_DRAWER]: i18n.t('形状'),
    [DrawerName.ANIMATION_RIGHT_DRAWER]: i18n.t('动画'),
    [DrawerName.COMMENT_DRAWER]: i18n.t('批注'),
    [DrawerName.SELECT_WINDOW_RIGHT_DRAWER]: i18n.t('图层'),
};

export const TabPanelIconMap = {
    [DrawerName.SLIDE_PROPERTY_DRAWER]: TOOLBAR_SHAPE,
    [DrawerName.ANIMATION_RIGHT_DRAWER]: TOOLBAR_ANIM,
    [DrawerName.COMMENT_DRAWER]: INSERT_COMMENT_ICON,
    [DrawerName.SELECT_WINDOW_RIGHT_DRAWER]: TOOLBAR_SELECT_WINDOW,
};
